import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services

// props
import { IPaginationResourceShort } from '../../../../../props/general';
import { IVendorResourceShortProps } from '../../../../../props/data/vendors';

// components
import { IColumn, SelectionMode, ShimmeredDetailsList, Stack } from '@fluentui/react';
import PermissionsService from '../../../../../services/permissions';
import { IVendorPICResourceShortProps } from '../../../../../props/data/vendors/pic';
import Text from './../../../../typography/text';
import VendorPICService from '../../../../../services/data/vendors/pics';
import { IDepositResourceShortProps } from '../../../../../props/finance/incomes/deposits';
import DepositService from '../../../../../services/finance/deposits';
import LoadingComponent from '../../../../feedbacks/loading';
import Details from '../../../../typography/details';
import GeneralService from '../../../../../services/general';
import DepositTransactionsList from '../../../../finances/deposits/transactions/general/list';

type VendorDepositDetailsProps = {
    vendorId: string;
}

const VendorDepositDetails: React.FC<VendorDepositDetailsProps> = (props: VendorDepositDetailsProps) => {
    const { banner, user } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [deposit, setDeposit] = React.useState<IDepositResourceShortProps | undefined>(undefined);

    const hasReadTransactionAccess = PermissionsService.hasPermission(['deposits.transactions.read.all'], user.permissions);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        const _deposit = await DepositService.read('vendor', props.vendorId);
        setDeposit(_deposit);
        setLoaded(true);
    }

    return <Stack tokens={{ childrenGap: 20 }}>
        {!loaded ? <LoadingComponent label={"Retrieving vendor deposit ..."} labelPosition={'right'} spinnerPosition={'baseline'} /> : null}
        {loaded && deposit ? <>
            <Details title={"Deposit amount"} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(deposit.amount))}`} />
        </> : null}
        {hasReadTransactionAccess ? <>
            <DepositTransactionsList qs={[`vendor_id=${props.vendorId}`]} hideCommandBar />
        </> : null}
    </Stack>;
};

export default VendorDepositDetails;
